export enum ReportPageTypes {
    StatusOfCertifications = 'statusOfCertifications',
    UncompletedRequirements = 'uncompletedRequirements',
    CertificationsByPerson = 'certificationsByPerson',
    KpiReports = 'kpiReports',
}
